import {css} from '@emotion/css';
import {colours, fonts, spacing} from '../../../../styles/js/variables';

const styles = {
  calculatorResult: (bordered?: boolean): string => css`
    label: CalculatorResultItem;
    flex: 1;
    border-radius: 10px;
    border: 2px solid transparent;
    padding: ${spacing.XXS};
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${bordered ? `border-color: ${colours.brand.PRIMARY};` : ''}
  `,
  // @todo: remove todo once paragraph is refactored to emotion
  title: css`
    label: CalculatorResultItem__title;
    margin-bottom: ${spacing.XXS} !important;
    color: ${colours.semantic.PLACEHOLDER_ACTIVE};
  `,
  // @todo: remove important once Paragraph component is refactored to emotion
  value: css`
    label: CalculatorResultItem__value;
    font-weight: ${fonts.weight.SEMI_BOLD};
    margin-bottom: 0 !important;
  `,
};

export default styles;
